import { Link } from "react-router-dom";
import { PageLoader, Main } from "components";
import getPlatformColor from "utils/getPlatformColor";
import useQueryHook from "utils/useQueryHook";
import { stringifyQuery } from "utils/api";

import { ReactComponent as CategoryIcon } from "icons/category.svg";

const PlatformTaxonsMain = () => {
  const {
    is_loading,
    is_fetching,
    data: { data },
  } = useQueryHook({
    query_keys: ["platforms"],
    path: `/platforms?${stringifyQuery({
      context: "ui_index",
      per_page: 1000,
    })}`,
  });

  if (is_loading || is_fetching) {
    return <PageLoader />;
  }

  return (
    <Main
      page={{
        name: "Kategorie platform",
        icon: <CategoryIcon />,
        breadcrumbs: [
          {
            name: "Kategorie platform",
          },
        ],
      }}
    >
      <ul className="category-list">
        {data?.length > 0 &&
          data.map(({ name, id }) => (
            <li className="category-item" key={id}>
              <Link
                to={`/platforms/${id}/platform_taxons`}
                className="category-item__name"
                style={{ color: getPlatformColor(name) }}
              >
                {name}
              </Link>
            </li>
          ))}
      </ul>
    </Main>
  );
};

export default PlatformTaxonsMain;
